// cod业务意向标签
export default {
  zh: {
      A: '可直接发货',
      B: '确认部分信息，可发货',
      C: '需修改地址',
      D: '拒绝参与',
      E: '用户无应答',
      F: '未接通',
      G: '语音信箱',
      H: '放弃资格',
      I: '用户暂忙',
      J: '意图不明'
  },
  en: {
      A: 'Ready to be dispatched',
      B: 'Comfirmed partial info, can be dispatched',
      C: 'Address need to be changed',
      D: 'Refuse to participate',
      E: 'No Voice',
      F: 'No Answer',
      G: 'Voicemail',
      H: 'Waiver of Eligibility',
      I: 'Busy',
      J: 'Not Recognized'
  },
  ba: {
      A: 'Bisa segera dikirimkan',
      B: 'Beberapa informasi sudah terkonfirmasi, bisa segera dikirimkan',
      C: 'Alamat pengiriman perlu diubah',
      D: 'Menolak untuk berpartisipasi',
      E: 'Tidak ada suara',
      F: 'Tidak terhubung',
      G: 'Kotak suara',
      H: 'Menyerah atas kelayakan',
      I: 'Sedang sibuk',
      J: 'Tidak jelas'
  }
}



// WEBPACK FOOTER //
// ./src/utils/intentionTags/codTags.js